import { render, staticRenderFns } from "./diagnosticas.vue?vue&type=template&id=df1082c0"
import script from "./diagnosticas.vue?vue&type=script&lang=js"
export * from "./diagnosticas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports